<template>
  <div class="app-shell">
    <main class="page-content" :class="{ 'with-bottom-nav': showBottomNav }">
      <router-view />
    </main>

    <nav v-if="showBottomNav" class="bottom-nav">
      <router-link to="/" class="bottom-nav__item">
        <span class="bottom-nav__icon">{{ isAdmin ? '▣' : '＋' }}</span>
        <span class="bottom-nav__text">{{ isAdmin ? 'Статистика' : 'Создать заявку' }}</span>
      </router-link>

      <router-link to="/requests" class="bottom-nav__item">
        <span class="bottom-nav__icon">≡</span>
        <span class="bottom-nav__text">Заявки</span>
      </router-link>

      <router-link to="/profile" class="bottom-nav__item">
        <span class="bottom-nav__icon">●</span>
        <span class="bottom-nav__text">Профиль</span>
      </router-link>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    showBottomNav() {
      return this.$route.path !== '/login' && this.$store.getters['auth/isAuthenticated']
    },
    isAdmin() {
      return this.$store.getters['auth/isAdmin']
    }
  }
}
</script>

<style>
* {
  box-sizing: border-box;
}

html,
body,
#app {
  margin: 0;
  min-height: 100%;
  font-family: Arial, Helvetica, sans-serif;
  background: #f5f7fb;
  color: #1f2937;
}

body {
  overscroll-behavior-y: contain;
}

a {
  text-decoration: none;
  color: inherit;
}

button,
input,
textarea,
select {
  font: inherit;
}

.app-shell {
  min-height: 100vh;
}

.page-content.with-bottom-nav {
  padding-bottom: 96px;
}

.bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding: 12px;
  background: #ffffff;
  border-top: 1px solid #e5e7eb;
  box-shadow: 0 -6px 20px rgba(15, 23, 42, 0.08);
  z-index: 100;
}

.bottom-nav__item {
  min-height: 64px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #6b7280;
  background: #f8fafc;
  transition: 0.2s ease;
  text-align: center;
  padding: 8px 6px;
}

.bottom-nav__item.router-link-exact-active {
  background: #111827;
  color: #ffffff;
}

.bottom-nav__icon {
  font-size: 18px;
  line-height: 1;
}

.bottom-nav__text {
  font-size: 12px;
  font-weight: 700;
}
</style>